// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1178":"0b5f11e1","1288":"783414fa","4337":"a9d02d98","5530":"5fb05d33"}[chunkId] + ".chunk.css";
};